import { makeApiRequest } from "../httpService";
// eslint-disable-next-line no-unused-vars
import { UserBasicDetailsMessage } from "./models/UserBasicDetailsMessage";
// eslint-disable-next-line no-unused-vars
import { AllowedSubscriptionFeaturesMessage } from "./models/AllowedSubscriptionFeaturesMessage";

export const getUserBasicDetails = async (
  { bypassSessionExpiryCheck = false } : {bypassSessionExpiryCheck? : boolean} = {}
) => {
  const result = await makeApiRequest<void, UserBasicDetailsMessage>(
    "/core/user/getUserBasicDetails",
    "GET",
    undefined,
    undefined,
    !bypassSessionExpiryCheck
  );
  return result;
};

export const getAllSubscriptionsAllowedFeatures = async () => {
  const result = await makeApiRequest<void, Array<AllowedSubscriptionFeaturesMessage>>(
    "/core/subscription/getAllSubscriptionsAllowedFeatures",
    "GET"
  );
  return result;
};
